/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetPossibleHostnames$Params {
  record_name: string;
  organisation_id: string;
  reverse_zone_id: number;
}

export function getPossibleHostnames(
  http: HttpClient,
  rootUrl: string,
  params: GetPossibleHostnames$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getPossibleHostnames.PATH, "get");
  if (params) {
    rb.path("record_name", params.record_name, {});
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("reverse_zone_id", params.reverse_zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    }),
  );
}

getPossibleHostnames.PATH =
  "/surfdomeinen/organisations/{organisation_id}/reverse/{reverse_zone_id}/records/hostnames/{record_name}";
